import { useCallback } from 'react';
import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { difference, intersection, pullAll, uniq } from 'lodash';
import { Result } from '@cp/shared/result';
// FIXME: sibling level import
import { useRelevantCatalogItemsAnimation } from 'src/features/catalog';
import { ClientSelection, withMappedSelection } from 'src/entities/client';
import { useClientSelectionService } from './useClientSelectionService';
import { SelectionType } from './clientSelectionService';
import { QuizQuestions, useQuizFeature } from './useQuizFeature';

type PrefilterSettings = {
  // ask event we already have answer
  requiredQuestions?: Array<keyof ClientSelection>;
  /** If possible do not ask these questions */
  omitQuestions?: Array<keyof ClientSelection>;
  predefinedValues?: ClientSelection;
  /** Do not show animation of relevant catalogItems */
  skipAnimation?: boolean;
};

export const usePrefilter = () => {
  const service = useClientSelectionService();
  const quiz = useQuizFeature();
  const showRelevantCatalogAnimation = useRelevantCatalogItemsAnimation();

  return useCallback(
    async ({ requiredQuestions = [], omitQuestions = [], predefinedValues, skipAnimation }: PrefilterSettings) => {
      console.debug('Start prefilter');
      if (predefinedValues) {
        service.register(withMappedSelection(predefinedValues), SelectionType.ClientAction);
      }
      const allSelections = service.getSelections();
      let currentSelection = service.getSelections(SelectionType.ClientAction);

      const relevantAnimationRequiredKeys: Array<keyof ClientSelection> = ['catalogType', 'cityId', 'careerId'];
      const defaultQuestions: Array<keyof ClientSelection> = pullAll(['catalogType', 'cityId', 'careerId'], Object.keys(currentSelection));

      const effectiveOmit = intersection(Object.keys(allSelections), omitQuestions);
      // Оставляем вопросы на которые клиент еще не отвечал
      const questions: QuizQuestions = uniq(requiredQuestions.concat(pullAll(defaultQuestions, effectiveOmit)));

      const quizResult = await quiz(questions);
      currentSelection = quizResult.unwrap();

      // Спрашивали срочность и человек просто смотрит -> выходим
      if (questions.includes('urgencyScore') && !currentSelection.urgencyScore) {
        return Result.Ok(currentSelection);
      }

      // check we have all required keys for relevant items
      if (!difference(relevantAnimationRequiredKeys, Object.keys(currentSelection)).length && !skipAnimation) {
        const { catalogType, careerId, cityId } = currentSelection as Required<ClientSelection>;
        const request: CatalogItemListRequest = { type: catalogType, careerId, cityId, pagination: 3, sorters: { createdAt: 'asc' } };
        await showRelevantCatalogAnimation(request);
      }

      return Result.Ok(currentSelection);
    },
    [service, quiz, showRelevantCatalogAnimation],
  );
};
